import React, { useState, useEffect, useContext, useRef } from 'react'
import { Form } from 'react-router-dom'
import Application from "../../../StateContext/Application";
import '../master.css'
import { Cancel32, DeleteRed32, EditBlueBlue32, submit, Tax32, UpdateWhite32, EditIcon, DeleteIcon, Edit32WHITE, Delete32WHITE } from '../../../../../public/LoginImages/importimages';
const Budget = () => {
  const statecalls = useContext(Application);
  const { AddBudget, GetBudget, UpdateBudget, DeleteBudget } = statecalls;
  const [isHovered, setIsHovered] = useState(false);
  const [formData, setFormData] = useState({
    Head: "",
    Fund: "",
    Approvals: "",
  });
  const [tableData, setTableData] = useState([]);
  const [editId, setEditId] = useState(null);
  const formdataref = useRef(null)
  const getbudget = async () => {
    let data = await GetBudget();
    setTableData(data);
  };

  useEffect(() => {
    getbudget();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let data;
    console.log("handlesubmit", formData);

    if (editId) {
      data = await UpdateBudget(editId, { id: editId, Head: formData.Head, Fund: formData.Fund, Approvals: formData.Approvals, });
      console.log("EditBud", data);

      if (data && data.message === "Budget Updated Successfully") {
        alert(data.message);
      } else {
        alert("Update failed. Please try again.");
      }
    } else {
      data = await AddBudget(formData.Head, formData.Fund, formData.Approvals);
      console.log("addBud", data);

      if (data && data.message === "Budget Added Successfully") {
        alert(data.message);
      } else {
        alert("Add failed. Please try again.");
      }
    }
    setEditId(null);
    setFormData({ Head: "", Fund: "", Approvals: "" });
    getbudget();
  };

  const handleEdit = (item) => {
    console.log(item);

    setFormData({
      Head: item.Head,
      Fund: item.Fund,
      Approvals: item.Approvals,
    });
    setEditId(item.id);

  };

  const handleDelete = async (e, id) => {
    e.preventDefault();
    if (window.confirm("Are you sure you want to delete this budget?")) {
      let data = await DeleteBudget(id);
      console.log("Delete response:", data);

      if (data && data.message === "Budget Deleted Successfully") {
        alert("Deleted successfully!");
        getbudget();
      } else {
        alert("Delete failed or no response from server.");
      }
    }
  };
  const resetData = () => {
    formdataref.current.reset()
    setFormData([])
  }
  return (
    <div
      style={{
        // marginLeft: "18.5rem",
        // // transition: "margin-left 0.3s ease",
        // backgroundColor: "#efecff", // full width background
        // minHeight: "100vh", // covers the full height
        // width: "100%", // full width coverage
        // display: "flex",
        // flexDirection: "column",
        // justifyContent: "center",
        // alignItems: "center",
        // padding: "30px", // spacing from top
        // boxSizing: "border-box",
        // overflowY: "auto",
        
        background: '#efecff', 
        width: 'auto',
        maxHeight: "92vh",
        // minHeight: '100vh',  
        transition: "margin-left 0.3s ease",
        overflowY: "auto",  
         msOverflowStyle: "none",       // IE & Edge
          scrollbarWidth: "none",
        
        padding: 40, 
        fontFamily: 'Inter, sans-serif'
      }}
    >


      <Form
        onSubmit={handleSubmit}
        ref={formdataref}
        style={{
          // marginLeft: "20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: 'center',
          alignItems: "center",
          // width: "100%",
          // maxWidth: "1130px",
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "10px",
          padding: "30px",
        }}
      >
        <h5 style={{ marginBottom: "20px", fontWeight: "700", color: "black", textAlign: "left", width: "100%" }}>
          <img src={"/Bill-Files-Details-32.png"} alt="Project Icon" style={{ marginRight: "10px", width: 28, height: 28 }} />
          Budget Master
        </h5>
        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            backgroundColor: "#f3f8fd",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <div
            style={{
              display: "grid",
              gap: "20px",
              width: "100%",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Head
              </label>
              <input
                type="text"
                className="form-control"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                }}
                id="Head"
                name="Head"
                value={formData.Head}
                onChange={handleInputChange}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Fund
              </label>
              <input
                type="number"
                className="form-control"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                }}
                id="Fund"
                name="Fund"
                value={formData.Fund}
                onChange={handleInputChange}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Approvals
              </label>
              <input
                type="number"
                className="form-control"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                }}
                id="Approvals"
                name="Approvals"
                value={formData.Approvals}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginTop: "20px",
              justifyContent: "center",
            }}
          >
            <button
              type="submit"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "20px",
                width: "120px",
                height: "40px",
                backgroundColor: "#39b54a",
                border: "none",
                fontSize: "16px",
                color: "#ffffff",
                fontWeight: "700",
              }}
            >
              {editId ? "Update" : "Submit"}
            </button>
            <button
              onClick={resetData}
              type="button"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "20px",
                width: "120px",
                height: "40px",
                backgroundColor: "#ee5d50",
                opacity: "50%",
                border: "none",
                fontSize: "16px",
                color: "#ffffff",
                fontWeight: "700",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </Form>

      <div
        style={{
          marginTop: "40px",
        //   marginLeft: "20px",
        //   width: "100%",
        //  maxWidth: "1130px",
        justifyContent:'center',
        alignItems:'center',
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "10px",
          padding: "20px",
        }}
        
      >
        <h5 style={{ marginBottom: "20px", fontWeight: "700", color: "black" }}>
          <img src={"/List-32.png"} alt="Project Icon" style={{ marginRight: "10px", width: 28, height: 28 }} />
          Add Bank Master List
        </h5>
        <table
          style={{
            backgroundColor: "white",
                    width: "100%",
                    minWidth: "1000px",
                    borderCollapse: "collapse"
          }}
        >
          <thead>
            <tr
              style={{
               backgroundColor: "#2ea4e7",
                            color: "white",
                            fontSize: "13px",
                            fontWeight: "600",
                            textAlign: "center",
                            whiteSpace: "nowrap"
              }}
            >
              <th style={{ padding: "8px" }}>Sr.No</th>
              <th style={{ padding: "8px" }}>Head</th>
              <th style={{ padding: "8px" }}>Fund</th>
              <th style={{ padding: "8px" }}>Approvals</th>
              <th style={{ padding: "8px" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((item, index) => (
              <tr
                key={item.id}
                style={{
                  backgroundColor: index % 2 === 0 ? "#ffffff" : "#f3f8fd",
                  height: "50px",
                }}
              >
                <td style={{ padding: "8px", fontSize: "14px", fontWeight: "700" }}>{index + 1}</td>
                <td style={{ padding: "8px", fontSize: "14px", fontWeight: "700" }}>{item.Head}</td>
                <td style={{ padding: "8px", fontSize: "14px", fontWeight: "700" }}>{item.Fund}</td>
                <td style={{ padding: "8px", fontSize: "14px", fontWeight: "700" }}>{item.Approvals}</td>
                <td style={{ padding: "8px" }}>
                  <button 
                    onClick={() => handleEdit(item)}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    style={{
                      backgroundColor: isHovered ? "#044c92" : "#ffffff",
                      border: "1px solid #044c92",
                      color: isHovered ? "#ffffff" : "#044c92",
                      borderRadius: "5px",
                      padding: "5px 10px",
                      fontWeight: "700",
                      fontSize: "15px"
                    }}
                  >
                    <img
                      src={isHovered ? Edit32WHITE : EditIcon}
                      alt="Edit Icon"
                      style={{ marginRight: "5px", width: 30, height: 30 }}
                    />
                    Edit
                  </button>
                  <button 
                    onClick={(e) => handleDelete(e, item.id)}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    style={{
                      backgroundColor: isHovered ? "#ee5d50" : "#ffffff",
                      border: "1px solid #ee5d50",
                      color: isHovered ? "#ffffff" : "#ee5d50",
                      borderRadius: "5px",
                      padding: "5px 10px",
                      marginLeft: "10px",
                      fontWeight: "700",
                      fontSize: "15px"
                    }}
                  >
                    <img
                      src={isHovered ? Delete32WHITE : DeleteIcon}
                      alt="Delete Icon"
                      style={{ marginRight: "5px", width: 30, height: 30 }}
                    />
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Budget;